export const snapshotManagementErrorsMessages = {
  en: {
    btnShowLog: 'CLI output',
    actionColumnTitle: 'Action',
  },
};
